export default "__VITE_ASSET__COAAbvQt__"